<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      合同管理
      <small>
        /&nbsp;
        <router-link to="/distributorlist" class="TitleStyle">合同列表</router-link>&nbsp;/&nbsp;新增合同
      </small>
    </h1>
    <!-- end col-6 -->
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->
        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">新增合同</h4>
              </div>
              <!-- end panel-heading -->
              <div class="OrderInfo">
                <div class="OrderGroup">
                  <div class="GTitle">
                    <span class="TInfo">合同信息</span>
                  </div>
                  <div class="GContent">
                    <el-form
                      :model="ruleForm"
                      :inline="true"
                      :rules="rules"
                      ref="ruleForm"
                      label-width="160px"
                      class="demo-form-inline"
                    >
                      <el-form-item label="签订时间:" prop="recom" class="labelstyle">
                        <el-input v-model="ruleForm.recom" class="DistributorMargin InputWidth"></el-input>
                      </el-form-item>
                      <el-form-item label="快递公司:" prop="recomName" class="labelstyle">
                        <el-input v-model="ruleForm.recomName" class="DistributorMargin InputWidth"></el-input>
                      </el-form-item>
                      <el-form-item label="上传合同:" prop="recomName" class="labelstyle">
                        <el-upload 
                          class="avatar-uploader DistributorMargin"
                          action="https://jsonplaceholder.typicode.com/posts/"
                          :show-file-list="false"
                          :on-success="handleAvatarSuccess"
                          :before-upload="beforeAvatarUpload">
                          <img v-if="imageUrl" :src="imageUrl" class="avatar">
                          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                        <!-- <el-progress :percentage="percentage" :status="percentagestatus" v-if="percentageShow"></el-progress> 
                        <span style="color: #F56C6C;font-size: 12px;" v-if="errorTip">必须上传图片</span> -->
                      </el-form-item>
                      <el-form-item label="快递单号:" prop="recomName" class="labelstyle">
                        <el-input v-model="ruleForm.recomName" class="DistributorMargin InputWidth"></el-input>
                      </el-form-item>
                      <el-form-item label="审核时间" prop="recomName" class="labelstyle">
                        <el-date-picker
                          v-model="ruleForm.orderTime"
                          type="datetime"
                          placeholder="请选择审核时间"
                          class="DistributorMargin InputWidth SHTime"
                          @change="ChangeTime">
                        </el-date-picker>
                      </el-form-item>
                      <el-form-item label="审核状态:" prop="recomName" class="labelstyle">
                        <el-input v-model="ruleForm.recomName" class="DistributorMargin InputWidth"></el-input>
                      </el-form-item>
                      <el-form-item label="审核信息" prop="recomName" style="width:100%">
                        <el-input type="textarea" v-model="ruleForm.recomName" class="DistributorMargin" style="width:700px"></el-input>
                      </el-form-item>
                      <el-form-item style="width:100%;padding-left:175px;">
                        <el-button type="primary">修改</el-button>
                        <el-button type="warning">提交</el-button>
                      </el-form-item>
                      <div class="clear"></div>
                    </el-form>
                  </div>
                  <div class="GTitle">
                    <span class="TInfo">交纳保证金信息</span>
                  </div>
                  <div class="GContent">
                    <el-form
                      :model="ruleForm"
                      :inline="true"
                      :rules="rules"
                      ref="ruleForm"
                      label-width="160px"
                      class="demo-form-inline"
                    >
                      <el-form-item label="交纳时间:" prop="recom" class="labelstyle">
                        <el-date-picker
                          v-model="ruleForm.orderTime"
                          type="datetime"
                          placeholder="请选择交纳时间"
                          class="DistributorMargin InputWidth SHTime"
                          @change="ChangeTime">
                        </el-date-picker>
                      </el-form-item>
                      <el-form-item label="审核时间" prop="recomName" class="labelstyle">
                        <el-date-picker
                          v-model="ruleForm.orderTime"
                          type="datetime"
                          placeholder="请选择审核时间"
                          class="DistributorMargin InputWidth SHTime"
                          @change="ChangeTime">
                        </el-date-picker>
                      </el-form-item>
                      <el-form-item label="交纳保证金:" prop="recomName" class="labelstyle">
                        <el-input v-model="ruleForm.recomName" class="DistributorMargin InputWidth"></el-input>
                      </el-form-item>
                      <el-form-item label="审核状态:" prop="recomName" class="labelstyle">
                        <el-input v-model="ruleForm.recomName" class="DistributorMargin InputWidth"></el-input>
                      </el-form-item>
                      <el-form-item label="上传凭证:" prop="recomName" class="labelstyle">
                        <el-upload 
                          class="avatar-uploader DistributorMargin"
                          action="https://jsonplaceholder.typicode.com/posts/"
                          :show-file-list="false"
                          :on-success="handleAvatarSuccess"
                          :before-upload="beforeAvatarUpload">
                          <img v-if="imageUrl" :src="imageUrl" class="avatar">
                          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                        <!-- <el-progress :percentage="percentage" :status="percentagestatus" v-if="percentageShow"></el-progress> 
                        <span style="color: #F56C6C;font-size: 12px;" v-if="errorTip">必须上传图片</span> -->
                      </el-form-item>
                      <el-form-item label="审核信息" prop="recomName" class="labelstyle">
                        <el-input type="textarea" :rows="4" v-model="ruleForm.recomName" class="DistributorMargin InputWidth"></el-input>
                      </el-form-item>
                      <el-form-item label="支付流水号:" prop="recomName" class="labelstyle">
                        <el-input v-model="ruleForm.recomName" class="DistributorMargin InputWidth"></el-input>
                      </el-form-item>
                      <el-form-item label="交纳说明" prop="recomName" class="labelstyle">
                        <el-input type="textarea" :rows="4" v-model="ruleForm.recomName" class="DistributorMargin InputWidth"></el-input>
                      </el-form-item>
                      <div class="clear"></div>
                    </el-form>
                  </div>
                  
                </div>
                
              </div>
            </div>
          </div>
          <!-- end panel -->

          <!-- end col-10 -->
        </div>

        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
  </div>
</template>
<script>
import Qs from "qs";
import axios from "axios";
import http from "@/common/http";

export default {
  name: "AddAgreement",
  data() {
    var checkrecom = (rule, value, callback) => {
      setTimeout(() => {
        var reg = /^[0-9A-Za-z]{1,16}$/;
        if (!reg.test(value)) {
          callback(new Error("渠道号由数字和字母组成且小于16位"));
        } else {
          callback();
        }
      }, 1000);
    };
    var checkrecomName = (rule, value, callback) => {
      setTimeout(() => {
        if (value.length > 32) {
          callback(new Error("名称必须小于33位"));
        } else {
          callback();
        }
      }, 1000);
    };

    return {
      ruleForm: {},
      rules: {
        recom: [
          { required: true, message: "请输入服务商渠道号", trigger: "blur" },
          { validator: checkrecom, trigger: "blur" }
        ],
        recomName: [
          { required: true, message: "请输入服务商名称", trigger: "blur" },
          { validator: checkrecomName, trigger: "blur" }
        ],
      },
      
      imageUrl: ""
    };
  },
  mounted: function() {
    
  },
  methods: {
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      const data = new FormData();
      data.append("file", file.raw);
      let that = this;
      let url = "distribution/FileController/uploadFileToFast";
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
          "Content-Type": "application/x-www-form-urlencoded"
        }
      };
      axios
        .post(url, data, config)
        .then(response => {
          if (response.data.code == 200) {
            that.ruleForm.logoUrl = response.data.data;
            that.percentageShow = true;

            setTimeout(() => {
              that.percentage = 100;
              that.percentagestatus = "success";
            }, 100);
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },
    beforeAvatarUpload(file) {
      let _this = this;
      _this.percentageShow = true;
      _this.percentage = 0;
      return new Promise((resolve, reject) => {
        let isLt2M = file.size / 1024 / 1024 < 10; // 判定图片大小是否小于10MB
        if (!isLt2M) {
          _this.$notify({
            title: "失败",
            message: "上传头像图片大小不能超过 10MB!",
            type: "error"
          });
          reject();
        }
        let image = new Image(),
          resultBlob = "";
        image.src = URL.createObjectURL(file);
        image.onload = () => {
          // 调用方法获取blob格式，方法写在下边
          resultBlob = _this.compressUpload(image);
          resolve(resultBlob);
        };
        image.onerror = () => {
          reject();
        };
      });
    },
    ChangeTime(){
      this.ruleForm.orderTime = this.FormatAllDate(this.ruleForm.orderTime);
    },
    FormatAllDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hours +
        seperator2 +
        minutes +
        seperator2 +
        seconds;

      return currentdate;
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
  list-style: none;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.OrderInfo {
  padding: 20px 30px;
}
.GTitle {
  border-top: 3px #84caf3 solid;
  overflow: hidden;
  line-height: 25px;
  border-right: 1px #e5e5e5 solid;
  background: #f4f4f4;
}
.TInfo {
  position: relative;
  min-width: 130px;
  float: left;
  font-size: 16px;
  padding: 5px 15px;
  background-color: #84caf3;
  color: #ffffff;
}
.GContent {
  padding: 20px;
  border: 1px #e5e5e5 solid;
  border-top: none;
  text-align: left;
}
.TitleStyle {
  color: #6a7786;
}
@media screen and (min-width: 1680px) {
  .labelstyle {
    width: 40%;
  }
  .InputWidth {
    width: 330px;
  }
}
@media screen and (min-width: 1440px) and (max-width: 1680px) {
  .labelstyle {
    width: 45%;
  }
  .InputWidth {
    width: 300px;
  }
}
@media screen and (min-width: 1308px) and (max-width: 1440px) {
  .labelstyle {
    width: 48%;
  }
  .InputWidth {
    width: 280px;
  }
}
@media screen and (max-width: 1308px) {
  .labelstyle {
    width: 75%;
  }
  .InputWidth {
    width: 350px;
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #8c939d;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/AgreementManage/AddAgreement.vue